import USDC_ABI from '@abis/usdc.json'
import USDT_ABI from '@abis/usdt.json'
import { 
    USDC_TOKEN_ADDRESS,
    USDT_TOKEN_ADDRESS
} from '@utils/addressHelper'
import USDC_ICON from '@images/ico_usdc.png'
import USDT_ICON from '@images/ico_usdt.png'

export const TOKENS_INFO = [
    {
        name: 'USDC',
        abi: USDC_ABI,
        address: USDC_TOKEN_ADDRESS,
        decimal: 6,
        logo: USDC_ICON
    },
    // {
    //     name: 'USDT',
    //     abi: USDT_ABI,
    //     address: USDT_TOKEN_ADDRESS,
    //     decimal: 6,
    //     logo: USDT_ICON
    // }
]